'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxIFrame } from './IFrame'

interface AlertBlokProps {
  blok: {
    // title: AlertProps['title']
    url: string
    frameHeight: string
    mobileFrameHeight: string
  } & SbBlokData
}

const IFrame: FC<AlertBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxIFrame
        src={blok.url}
        frameHeight={blok.frameHeight}
        mobileFrameHeight={blok.mobileFrameHeight ? blok.mobileFrameHeight : blok.frameHeight}
      />
    </div>
  )
}

export default IFrame
